import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';

class TasksDirectoryState {
  store = new DomainStore();
  history;
  config;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history, config}) {
    this.history = history;
    this.config = config;
  }

  async removeTaskTemplate(taskTemplate) {
    await this.store.destroy(taskTemplate);
    successAlert(t('company_settings.tasks.alerts.Task template deleted.'));
  }

  goToAddTaskTemplate() {
    this.history.push(`/tasks/edit/${this.config.templateType}`);
  }
}

export default TasksDirectoryState;
